import { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalLabel, setLabel] = useState("");
  const [modalFullScreen, setFullScreen] = useState(false);
  const [modalOptions, setModalOptions] = useState({});

  /**
   * Affiche une modale
   * @param {ReactNode} modalContent - contenu de la modale
   * @param {object} options
   *   - hideHeader          : masque la barre d'en-tête (label + croix), le contenu gère son propre titre
   *   - closeOnOutsideClick : ferme la modale au clic sur le fond
   */
  const showModal = (modalContent, options = {}) => {
    setModalContent(modalContent);
    setModalOptions(options);
    setIsModalVisible(true);
  };

  const hideModal = () => {
    setIsModalVisible(false);
    setModalContent(null);
    setModalOptions({});
  };

  const setModalLabel = (value) => {
    setLabel(value);
  };

  const setModalFullScreen = (value) => {
    setFullScreen(value);
  };

  return (
    <ModalContext.Provider
      value={{
        isModalVisible,
        modalContent,
        showModal,
        hideModal,
        modalLabel,
        setModalLabel,
        modalFullScreen,
        setModalFullScreen,
        modalOptions,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};
